<template>
  <b-container style="">
    <div style="display: flex">
      <b-breadcrumb :items="items" style="margin-top: 16px"></b-breadcrumb>
    </div>

    <div v-if="!loaded" class="text-center">
          <b-spinner />
        </div>

    <b-row style="padding-top: 8px" v-if="this.hotel.hotelId">
      <b-col v-if="this.hotel.hotelId" style="overflow: auto">
          <b-form-group>
          <label style="padding-bottom: 4px">Hotel Name</label>
          <b-form-input placeholder="Id" v-model="this.hotel.name" disabled />
        </b-form-group>
        <b-form-group>
          <label style="padding-bottom: 4px">Hotel Id</label>
          <b-form-input v-model="this.hotel.hotelId" disabled />
        </b-form-group>
        <b-form-group>
          <label style="padding-bottom: 4px">Amenities</label>
          <b-form-input v-model="this.hotel.amenities" disabled />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row style="padding-top: 8px">
      <b-col v-if="this.offer.id" style="overflow: auto">
        <div>
          <b-form-group>
            <label style="padding-bottom: 4px">Id</label>
            <b-form-input placeholder="Id" v-model="this.offer.id" disabled />
          </b-form-group>

          <b-form-group v-if="this.offer.room && this.offer.room.description">
            <label style="padding-bottom: 4px">Description</label>
            <b-form-textarea
              v-model="this.offer.room.description.text"
              disabled
            />
          </b-form-group>

          <b-form-group v-if="this.offer.policies.cancellation && this.offer.policies.cancellation.description">
            <label style="padding-bottom: 4px">Cancellation Policy</label>
            <b-form-textarea
              v-model="this.offer.policies.cancellation.description.text"
              disabled
            />
          </b-form-group>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      hotel: {},
      offer: {},
      loaded: false,
      items: [
        {
          text: "Hotels",
          href: "#/"
        },
        {
          text: `Offer Id: ${this.$route.params.id}`
        }
      ]
    };
  },
  mounted() {
    this.fetchDetails();
  },
  methods: {
    async fetchDetails() {
      const id = this.$route.params.id;
      const response = await fetch(`/offer/details_json?id=${id}`);
      this.loaded = true
      const json = await response.json();
      const data = json.data;
    //   console.log(data)

      this.hotel = data.hotel;

      if (json.data.offers.length > 0) {
        this.offer = json.data.offers[0];
      }
    },
    handleSelect(offer) {
      this.selectedOffer = offer;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/OfferDetails.vue